import React, { useState } from "react";

const reviews = [
  {
    id: 1,
    name: "Shivani Sharma",
    title: "Software Engineer",
    text:
      "The team was professional and helpful throughout. They understood our business needs and provided a customized solution. Great experience!",
  },
  {
    id: 2,
    name: "Ranvir Singh",
    title: "Marketing Manager",
    text:
      "Best rates in the market with excellent customer service. The entire loan process was completed in just 3 days. Thank you, Pawan Sut!",
  },
  {
    id: 3,
    name: "Rajesh Kumar",
    title: "Business Analyst",
    text:
      "Simple, fast, and secure. It is so easy to track my loan and payments. Pawan Sut made my emergency expense stress-free.",
  },
  {
    id: 4,
    name: "Neha Verma",
    title: "Entrepreneur",
    text:
      "Pawan Sut’s flexible repayment options made it easy for me to manage my working capital. The team guided me at every step.",
  },
  {
    id: 5,
    name: "Ankit Joshi",
    title: "Chartered Accountant",
    text:
      "Very transparent process and quick support on queries. I recommend them to my clients who need reliable financing options.",
  },
  {
    id: 6,
    name: "Pooja Nair",
    title: "Consultant",
    text:
      "From application to disbursal, everything was smooth and digital. The interest rates were competitive and clearly explained.",
  },
];

const Stars = () => (
  <div className="flex gap-1 mb-4" aria-label="5 star rating">
    {Array.from({ length: 5 }).map((_, i) => (
      <span key={i} className="text-[#FFB400] text-lg">★</span>
    ))}
  </div>
);

const CustomerReviews = () => {
  const pageSize = 3;
  const totalPages = Math.ceil(reviews.length / pageSize);
  const [page, setPage] = useState(0);

  const startIndex = page * pageSize;
  const visibleReviews = reviews.slice(startIndex, startIndex + pageSize);

  const goPrev = () => {
    setPage((prev) => (prev === 0 ? totalPages - 1 : prev - 1));
  };

  const goNext = () => {
    setPage((prev) => (prev === totalPages - 1 ? 0 : prev + 1));
  };

  return (
    <section
      className="relative w-full py-12 md:py-16 lg:py-20 px-4 md:px-8 lg:px-16"
      style={{
        backgroundImage: 'url(/bg3.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-3">
            What Our <span className="text-blue-600">Customers Say</span>
          </h2>
          <p className="text-base md:text-lg text-slate-600">
            Join thousands of satisfied customers who trust Pawan Sut
          </p>
        </div>

        {/* Cards - slider showing 3 at a time */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-8 md:mb-10">
          {visibleReviews.map((review) => (
            <article
              key={review.id}
              className="bg-white/95 rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 border border-slate-100 flex flex-col"
            >
              <div className="px-6 pt-6 pb-4 md:px-7 md:pt-7 md:pb-5 flex-1 flex flex-col">
                <Stars />
                <p className="text-sm md:text-base text-slate-700 leading-relaxed flex-1">
                  {review.text}
                </p>
              </div>
              <div className="border-t border-slate-200 px-6 py-4 md:px-7 md:py-5 flex items-center gap-3">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center font-semibold text-sm md:text-base">
                  {review.name
                    .split(" ")
                    .map((n) => n[0])
                    .join("")}
                </div>
                <div>
                  <p className="text-sm md:text-base font-semibold text-slate-900">
                    {review.name}
                  </p>
                  <p className="text-xs md:text-sm text-slate-500">{review.title}</p>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Arrows + Dots */}
        <div className="flex items-center justify-center gap-6 md:gap-8">
          <button
            type="button"
            className="w-10 h-10 md:w-12 md:h-12 rounded-full border border-slate-200 bg-white flex items-center justify-center text-slate-600 shadow-sm hover:bg-blue-600 hover:text-white hover:border-transparent transition-all"
            onClick={goPrev}
            aria-label="Previous testimonials"
          >
            <svg width="22" height="22" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <div className="flex items-center gap-2" aria-label="Testimonials pages">
            {Array.from({ length: totalPages }).map((_, idx) => (
              <button
                key={idx}
                type="button"
                onClick={() => setPage(idx)}
                className={
                  idx === page
                    ? "w-6 h-2 rounded-full bg-blue-600"
                    : "w-2 h-2 rounded-full bg-slate-300"
                }
                aria-label={`Go to testimonials set ${idx + 1}`}
                aria-current={idx === page}
              />
            ))}
          </div>
          <button
            type="button"
            className="w-10 h-10 md:w-12 md:h-12 rounded-full border border-slate-200 bg-blue-600 flex items-center justify-center text-white shadow-sm hover:bg-blue-700 hover:border-transparent transition-all"
            onClick={goNext}
            aria-label="Next testimonials"
          >
            <svg width="22" height="22" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default CustomerReviews;

